<template>
	<div class="row">
		<div class="col">
			<h2 class="mb-0 font-size-xs-25">
				<fa-icon
					:icon="['fa','question-circle']"
					class="mr-2"
				/> Resetear claves
			</h2>

			<div>
				Introduce tu nick o email de usuario y te envíaremos un
				correo con un código para restablecer tu clave
			</div>

			<div class="py-4" />

			<validation-observer v-slot="{ passes, invalid }">
				<validation-provider
					v-slot="slotProps"
					rules="required"
				>
					<a-form-item
						:validate-status="$helpers.validateStatus(slotProps)"
						:help="slotProps.errors[0]"
						class="mb-4 text-left"
					>
						<a-input-search
							v-focus
							:value="value"
							size="large"
							placeholder="JhonDoe"
							enter-button
							:loading="loading"
							@search="passes(requestPassword())"
							@change="$emit('input',$event.target.value)"
						/>
					</a-form-item>
				</validation-provider>

				<router-link
					:to="{ name: '_login' }"
					class="d-inline-flex float-left align-items-center"
				>
					<fa-icon
						:icon="['fa','sign-in-alt']"
						class="mr-2"
					/> Iniciar sesión
				</router-link>

				<a
					class="float-right d-inline-flex align-items-center"
					:class="{
						'text-muted' : invalid,
						'text-light-primary': !invalid
					}"
					@click="$emit('next')"
				>
					<fa-icon
						:icon="['fa','barcode']"
						class="mr-2"
					/> Tengo un código
				</a>
			</validation-observer>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		value: {
			type: String,
			default: ''
		}
	},
	data() {
		return {
			error: '',
			loading: false
		};
	},
	methods: {
		async requestPassword() {
			this.$nprogress.start();
			this.loading = true;

			const forgot = await this.$gestios.auth.forgot(this.value);

			if (forgot.ok) {
				this.$store.dispatch('gestios/auth/nick', this.value);
				this.$toast.success('Se te ha enviado un email con un código para autorizar el cambio de contraseña');
				this.$emit('next');
			} else {
				this.$toast.error(forgot.message);
			}

			this.loading = false;
			this.$nprogress.done();
		}
	}
};
</script>

<style module>

</style>
